import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { applyLocaleToPath, stripLocaleFromPath } from 'routing/paths';
import useLocalizedNavigate from '~/hooks/useLocalizedNavigate';
import SelectMenuItem from '~/reusable-components/navigation/NavigationMenuList/SelectMenuItem';
import { useI18n } from '~/stores/i18n';
import { getLanguageList } from '~/utils/i18n';

type LanguageMenuItemProps = {
  onClick?: () => void;
};

function LanguageMenuItem({ onClick }: LanguageMenuItemProps) {
  const { lang, setLang } = useI18n();
  const location = useLocation();
  const navigate = useLocalizedNavigate();
  const languages = useMemo(() => getLanguageList(), []);
  const selectedLanguage = lang;
  const onLanguageChange = (newValue: string) => {
    const newPathname = applyLocaleToPath(
      stripLocaleFromPath(location.pathname),
      newValue,
    );

    // Navigate and update store simultaneously to prevent race condition
    // with LocaleLayout's locale sync logic
    navigate(
      {
        pathname: newPathname,
        search: location.search,
      },
      { replace: true, skipLocale: true },
    );
    void setLang(newValue, 'selector');
    onClick?.();
  };

  const options = languages.map((language) => ({
    label: language.name,
    value: language.code,
  }));

  return (
    <SelectMenuItem
      selectedItem={selectedLanguage}
      options={options}
      onSelect={onLanguageChange}
      label="Language"
    />
  );
}

export default LanguageMenuItem;
